import { render } from "./EditAssurance.vue?vue&type=template&id=5f646afb&scoped=true"
import script from "./EditAssurance.vue?vue&type=script&lang=js"
export * from "./EditAssurance.vue?vue&type=script&lang=js"

import "./EditAssurance.vue?vue&type=style&index=0&id=5f646afb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f646afb"]])

export default __exports__